export default {
      id: "icon-filter-usage",
      viewBox: "0 0 1792 1792",
      url: "/" + "assets/sprite.svg#icon-filter",
      toString: function () {
        return this.url;
      }
    }